import React from "react";
import Fondo2 from "../../../assets/img/promocionBlustay/fondo2.png";
const Gestion = () => {
    return (
        <div className="w-full flex flex-col justify-center items-center mt-5">
            <img src={Fondo2} alt="fondo" className="w-full" />

            <div className="w-3/4 text-center mt-5 md:text-base text-sm">
                Blustay es un sistema completo todo en uno que mejora la gestión
                de hoteles y propiedades: resuelve los más grandes problemas del
                sector hotelero y de alquileres. ¿Listo para recuperar el
                control de tu negocio? ideal para...
            </div>

            <div className="flex justify-center items-center w-3/4 mx-auto rounded-lg md:py-6 gap-1 md:gap-3 py-4 px-5 mt-6 shadow-[6px_8px_12px_0px_rgba(0,_0,_0,_0.8)] ">
                <div className="flex flex-col justify-center items-center gap-2">
                    <div className=" md:w-14 md:h-14 w-12 h-12 rounded-full flex justify-center items-center bg-[#029DE0] ">
                        <div className=" md:w-12 md:h-12 w-10 h-10 rounded-full bg-[#03062B] flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className=" md:w-10 md:h-10 w-8 h-8 text-white"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.364V3h-3v18m3-13.636 10.5-3.819"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="text-xs md:text-sm text-center">
                        Gestores de hoteles
                    </div>
                </div>

                <div className="flex flex-col justify-center items-center gap-2">
                    <div className="md:w-14 md:h-14 w-12 h-12 rounded-full flex justify-center items-center bg-[#029DE0] ">
                        <div className="md:w-12 md:h-12 w-10 h-10 rounded-full bg-[#03062B] flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className=" md:w-10 md:h-10 w-8 h-8 text-white"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="text-xs md:text-sm text-center">
                        Propietarios de inmuebles
                    </div>
                </div>

                <div className="flex flex-col justify-center items-center gap-2">
                    <div className="md:w-14 md:h-14 w-12 h-12 rounded-full flex justify-center items-center bg-[#029DE0] ">
                        <div className="md:w-12 md:h-12 w-10 h-10 rounded-full bg-[#03062B] flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className=" md:w-10 md:h-10 w-8 h-8 text-white"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="text-xs md:text-sm text-center">
                        Corredores inmobiliarios
                    </div>
                </div>
            </div>

            <div className="flex flex-col justify-center items-center w-3/4 mx-auto rounded-lg md:py-6 py-4 md:px-7 px-5 gap-2 mt-6 shadow-[6px_8px_12px_0px_rgba(0,_0,_0,_0.8)] ">
                <div className="text-2xl font-extrabold text-[#029DE0] uppercase ">
                    0$ de comisión
                </div>
                <div className=" w-24  border-b-2 border-[#029DE0] mx-auto  "></div>
                <div className="xs400:text-sm text-xs text-center mt-1">
                    Mientras otras plataformas se llevan hasta un 20% de tu
                    facturación, nuestro sistema de reservas directas te
                    garantiza que el total del pago se quede contigo. Aumenta tu
                    rentabilidad en cada reserva y deja de perder dinero.
                </div>
            </div>

            <div className="flex flex-col justify-center items-center w-3/4 mx-auto rounded-lg md:py-6 py-4 md:px-7  px-5 gap-2 mt-6 shadow-[6px_8px_12px_0px_rgba(0,_0,_0,_0.8)] ">
                <div className="text-xl text-center font-extrabold text-[#029DE0] uppercase ">
                    Calendario integrado
                </div>
                <div className=" w-24  border-b-2 border-[#029DE0] mx-auto  "></div>
                <div className="xs400:text-sm  text-xs text-center mt-1">
                    Evita el overbooking para siempre. Nuestro calendario
                    unifica tus reservas de Booking, Airbnb y tu web en una sola
                    vista, actualizándose en tiempo real para darte control
                    total.
                </div>
            </div>
        </div>
    );
};

export default Gestion;
